import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AppEvents } from 'src/app/app.config/app-events';
import { ConstantesApp } from 'src/app/app.config/constantes-app';
import { Beneficiario } from 'src/app/app.domain.models/beneficiario';
import { Cliente } from 'src/app/app.domain.models/cliente';
import { Poliza } from 'src/app/app.domain.models/poliza';
import { TipoPeriodicidad } from 'src/app/app.domain.models/tipo-periodicidad';
import { TipoSexo } from 'src/app/app.domain.models/tipo-sexo';
import { ClienteApiService } from 'src/app/app.domain.services/cliente.api.service';
import { FileApiService } from 'src/app/app.domain.services/file.api.service';
import { FirmaOperacionService } from 'src/app/app.domain.services/operacion.service';
import { TipoPeriodicidadApiService } from 'src/app/app.domain.services/tipo-periodicidad.api.service';
import { TipoSexoApiService } from 'src/app/app.domain.services/tipo-sexo.api.service';
import { PolizaApiService } from 'src/app/app.modules/individual/domain.services/poliza.api.service';
import { ArchivoCliente } from 'src/app/core.models/archivoCliente';
import { EventBrokerService } from 'src/app/core.services/event-broker.service';
import { SesionService } from 'src/app/core.services/sesion.service';
import { ConstantesCore } from 'src/app/core.utilidades/constantes-core';
import { Utilidades } from 'src/app/core.utilidades/utilidades';
import Tesseract from 'tesseract.js';
import { FirmaClienteComunComponent } from '../../componentes-compartidos/firma-cliente-comun/firma-cliente-comun.component';
import { ModalDireccionEnvioComponent } from '../../modales/modal-direccion-envio-dialog/modal-direccion-envio.component';
import { ModalFechaIdentificacionErroneaComponent } from '../../modales/modal-fecha-identificacion-no-coincide/modal-fecha-identificacion-erronea.component';
import { ModalPoliticaPrivacidadInformarUsuarioComponent } from '../../modales/modal-politica-privacidad-informar-usuario/modal-politica-privacidad-informar-usuario.component';

@Component({
    selector: 'app-contratar',
    templateUrl: './contratar.component.html',
    styleUrls: ['./contratar.component.scss'],
})
export class ContratarComponent implements OnInit {
    @ViewChild('imageInput') imageInput!: ElementRef;

    readonly CONSTANTES = ConstantesApp;

    beneficiarios: Beneficiario[] = [];
    tiposSexo!: TipoSexo[];
    tiposPeriodicidad!: TipoPeriodicidad[];

    mensajeValidacionForm: string = '';
    comunicarBeneficiarios: boolean = false;

    iconoDatosPersonales = ConstantesCore.ICONO_ARCHIVO;
    iconoBeneficiarioGris = ConstantesCore.ICONO_BENEFICIARIOS_GRIS;
    iconoBeneficiario = ConstantesCore.ICONO_BENEFICIARIOS;
    iconoBancoGris = ConstantesCore.ICONO_BANCO_GRIS;
    iconoBanco = ConstantesCore.ICONO_BANCO;

    cliente!: Cliente;
    poliza = new Poliza();

    formDatosPersonales: FormGroup;
    formCuentaBancaria: FormGroup;
    credencialesCorrectas: boolean = false;

    validacionFechaNacimiento: boolean = true;
    recognizedText: string = '';
    isLoading: boolean = false;

    nombreArchivoRecibo: string = '';

    formBeneficiarios = this.fb.group({
        beneficiarioItems: this.fb.array([])
    });

    formBeneficiario: FormGroup;
    formBeneficiarioBanco: FormGroup;

    formularioDatos: string = "datos-personales";
    formularioBeneficiarios: string = "beneficiarios";
    formularioBeneficiariosHip: string = "beneficiarios-hipoteca";
    formularioCuentaBan: string = "cuenta-bancaria";

    formDataRecibo: FormData;

    pasoActual: number = 1;
    totalPasos: number = 3;
    barraProgreso: number[];

    isFamilia!: boolean;

    comprobarSesion = false;

    constructor(
        private router: Router,
        private sesion: SesionService,
        private fb: FormBuilder,
        private translateService: TranslateService,
        private toastr: ToastrService,
        public dialog: MatDialog,
        private tipoSexoService: TipoSexoApiService,
        private tipoPeriodicidadService: TipoPeriodicidadApiService,
        private eventService: EventBrokerService,
        private fileService: FileApiService,
        private datePipe: DatePipe,
        private clienteApiService: ClienteApiService,
        private operacionService: FirmaOperacionService,
        private route: ActivatedRoute,
        private polizaService: PolizaApiService,
    ) {
        this.formDatosPersonales = new FormGroup({
            nombre: new FormControl('', [Validators.required, Validators.pattern(ConstantesApp.CADENA_TEXTO), Validators.maxLength(60),]),
            primerApellido: new FormControl('', [Validators.required, Validators.pattern(ConstantesApp.CADENA_TEXTO), Validators.maxLength(60),]),
            segundoApellido: new FormControl('', [Validators.pattern(ConstantesApp.CADENA_TEXTO), Validators.maxLength(60)]),
            identificacion: new FormControl('', [Validators.required, Validators.maxLength(10), Validators.pattern(ConstantesApp.DNI_NIE_FORMATO)]),
            telefono: new FormControl('', [Validators.required, Validators.pattern(ConstantesApp.REGEX_TELEFONO)]),
            tipoSexo: new FormControl('', [Validators.required, Validators.min(1)]),
            profesion: new FormControl('', [Validators.required, Validators.pattern(ConstantesApp.CADENA_TEXTO), Validators.maxLength(60)]),
        });

        this.formCuentaBancaria = new FormGroup({
            titularCuenta: new FormControl('', [Validators.required, Validators.pattern(ConstantesApp.CADENA_TEXTO), Validators.maxLength(255)]),
            ibanCuenta: new FormControl('', [Validators.required, Validators.pattern(ConstantesApp.REGEX_IBAN)]),
            periodicidad: new FormControl('', [Validators.required])
        });
        this.formBeneficiario = this.getFormGroupBeneficioVacio(false);

        this.formBeneficiarioBanco = this.getFormGroupBeneficioBancoVacio();

        this.formDataRecibo = new FormData();

        this.barraProgreso = Array.from({ length: this.totalPasos }, (_, index) => index);
    }

    ngOnInit() {
        this.tipoSexoService.listar().then(tipos => {
            this.tiposSexo = tipos as TipoSexo[];
        });
        this.tipoPeriodicidadService.listar().then(tipos => {
            const precio_mensual = this.poliza.precioMensual;

            if (precio_mensual >= 50) {
                this.tiposPeriodicidad = tipos as TipoPeriodicidad[];
            } else {
                this.tiposPeriodicidad = (tipos as TipoPeriodicidad[]).filter(tipo => tipo.descripcion.toLowerCase() !== 'mensual');
            }
        });
        this.route.queryParamMap.subscribe(params => {
            const tokenFirma = params.get('token');
            if (tokenFirma) {
                this.operacionService.obtenerDatosTokenCarritoAbandonado(tokenFirma).then((response: number) => {
                    this.polizaService.obtenerById(response).then((polizaResponse) => {
                        if (polizaResponse) {
                            this.poliza = polizaResponse;
                            this.cliente = this.poliza.cliente;
                            this.sesion.setCliente(this.cliente);
                            this.sesion.setPoliza(this.poliza);
                            this.rellenarFormulario();
                        }
                    });
                });
            } else {
                this.cliente = this.sesion.getCliente();
                this.poliza = this.sesion.getPoliza();
                this.rellenarFormulario();
            }
        });
    }

    rellenarFormulario() {
        this.comprobarPolizaSesion();

        if (this.comprobarSesion) {

            this.beneficiarios = this.poliza.beneficiarioList || [];
            this.beneficiarios.sort((a, b) => a.orden! - b.orden!);

            this.isFamilia = this.poliza.tipoPoliza.id === 1 ? true : false;
            this.formDatosPersonales = new FormGroup({
                nombre: new FormControl(this.cliente.nombre, [Validators.required, Validators.pattern(ConstantesApp.CADENA_TEXTO), Validators.maxLength(60),]),
                primerApellido: new FormControl(this.cliente.apellido1, [Validators.required, Validators.pattern(ConstantesApp.CADENA_TEXTO), Validators.maxLength(60),]),
                segundoApellido: new FormControl(this.cliente.apellido2, [Validators.pattern(ConstantesApp.CADENA_TEXTO), Validators.maxLength(60)]),
                identificacion: new FormControl(this.cliente.identificacion, [Validators.required, Validators.maxLength(10), Validators.pattern(ConstantesApp.DNI_NIE_FORMATO)]),
                telefono: new FormControl(this.cliente.telefono, [Validators.required, Validators.pattern(ConstantesApp.REGEX_TELEFONO)]),
                tipoSexo: new FormControl(this.cliente.tipoSexo ? this.cliente.tipoSexo.id : '', [Validators.required, Validators.min(1)]),
                profesion: new FormControl(this.cliente.profesion, [Validators.required, Validators.pattern(ConstantesApp.CADENA_TEXTO), Validators.maxLength(60)]),
            });

            this.formCuentaBancaria = new FormGroup({
                titularCuenta: new FormControl(this.poliza.titularCuenta, [Validators.required, Validators.pattern(ConstantesApp.CADENA_TEXTO), Validators.maxLength(255)]),
                ibanCuenta: new FormControl(this.poliza.ibanCuenta, [Validators.required, Validators.pattern(ConstantesApp.REGEX_IBAN)]),
                periodicidad: new FormControl(this.poliza.tipoPeriodicidad ? this.poliza.tipoPeriodicidad.id : 1, [Validators.required])
            });
            this.formBeneficiario = this.getFormGroupBeneficioVacio(false);

            this.formBeneficiarioBanco = this.getFormGroupBeneficioBancoVacio();

            if (this.poliza.tipoPoliza.id === 2) {
                this.addBeneficiario(this.getFormGroupBeneficioBancoVacio());
            } else {
                this.addBeneficiario(this.getFormGroupBeneficioVacio(true));
            }

            this.formDataRecibo = new FormData();
        }
    }

    comprobarPolizaSesion() {
        if (!this.sesion.getPoliza()?.id) {
            this.router.navigate([ConstantesApp.PATH_FORBIDDEN]);
        } else {
            this.comprobarSesion = true;
            this.poliza.ultimaPantalla = ConstantesApp.PATH_COLECTIVOS_5_CONTRATAR;
            this.eventService.publishEvent(AppEvents.actualizarUltimaAccion, this.poliza);
            this.eventService.publishEvent(AppEvents.actualizarColectivo, this.poliza.colectivo);

            if (this.beneficiarios.length > 0) {
                const primerBeneficiario = this.beneficiarios[0];
                this.formBeneficiarios.controls.beneficiarioItems.controls[0].patchValue({
                    nombreCompleto: primerBeneficiario.nombreCompleto,
                    porcentaje: primerBeneficiario.porcentaje,
                    dni: primerBeneficiario.dni,
                    tipoRelacion: primerBeneficiario.tipoRelacion,
                    email: primerBeneficiario.email,
                    comunicarEmail: primerBeneficiario.comunicarEmail,
                    nombreBanco: primerBeneficiario.nombreBanco,
                    numeroPrestamo: primerBeneficiario.numeroPrestamo,
                    orden: primerBeneficiario.orden
                });

                for (let i = 1; i < this.beneficiarios.length; i++) {
                    const beneficiario = this.beneficiarios[i];
                    const formGroup = this.fb.group({
                        nombreCompleto: [beneficiario.nombreCompleto, [Validators.required, Validators.pattern(ConstantesApp.CADENA_TEXTO)]],
                        porcentaje: [beneficiario.porcentaje, [
                            this.isFamilia ? Validators.required : null,
                            this.isFamilia ? Validators.maxLength(255) : null,
                            this.isFamilia ? Validators.pattern(ConstantesApp.NUMEROS_ENTEROS_PORCENTAJE) : null
                        ].filter(v => v !== null)],
                        email: [beneficiario.email],
                        dni: [beneficiario.dni],
                        tipoRelacion: [beneficiario.tipoRelacion ? beneficiario.tipoRelacion : null, [Validators.required, Validators.pattern(ConstantesApp.CADENA_TEXTO)]],
                        comunicarEmail: [beneficiario.comunicarEmail],
                        nombreBanco: [beneficiario.nombreBanco],
                        numeroPrestamo: [beneficiario.numeroPrestamo],
                        orden: [beneficiario.orden],
                    });
                    this.addBeneficiario(formGroup);
                }
            }
        }
    }

    get getFormDatosPersonales(): { [key: string]: AbstractControl } { return this.formDatosPersonales.controls; }
    get getFormCuentaBancaria(): { [key: string]: AbstractControl } { return this.formCuentaBancaria.controls; }

    get beneficiarioItems() {
        return this.formBeneficiarios.controls["beneficiarioItems"] as FormArray;
    }

    getError(data: any, formulario: string) {
        let transMessageError = Utilidades.obtenerErrorFormControl(data, formulario);
        if (transMessageError != "") return this.translateService.instant(transMessageError);
        return "";
    }

    getFormGroupBeneficioVacio(esPrimero: boolean): FormGroup {
        if (esPrimero) {
            return this.fb.group({
                nombreCompleto: ['', [Validators.required, Validators.pattern(ConstantesApp.CADENA_TEXTO)]],
                porcentaje: [this.isFamilia ? 100 : 0,
                this.isFamilia
                    ? [Validators.maxLength(255), Validators.pattern(ConstantesApp.NUMEROS_ENTEROS_PORCENTAJE)]
                    : [Validators.nullValidator]],
                dni: ['', [Validators.maxLength(255), Validators.pattern(ConstantesApp.DNI_NIE_FORMATO)]],
                tipoRelacion: ['', [Validators.required, Validators.nullValidator, Validators.pattern(ConstantesApp.CADENA_TEXTO)]],
                email: [''],
                comunicarEmail: [false],
                orden: [1],
            });
        } else {
            return this.fb.group({
                nombreCompleto: ['', [Validators.required, Validators.pattern(ConstantesApp.CADENA_TEXTO)]],
                porcentaje: [this.isFamilia ? '' : 0,
                this.isFamilia
                    ? [Validators.maxLength(255), Validators.pattern(ConstantesApp.NUMEROS_ENTEROS_PORCENTAJE)]
                    : [Validators.nullValidator]],
                dni: ['', [Validators.maxLength(255), Validators.pattern(ConstantesApp.DNI_NIE_FORMATO)]],
                tipoRelacion: ['', [Validators.required, Validators.nullValidator, Validators.pattern(ConstantesApp.CADENA_TEXTO)]],
                email: [''],
                comunicarEmail: [false],
                orden: [1],
            });
        }

    }

    getFormGroupBeneficioBancoVacio(): FormGroup {
        return this.fb.group({
            nombreCompleto: [''],
            porcentaje: [0],
            email: [''],
            comunicarEmail: [false],

            nombreBanco: ['', [Validators.required, Validators.maxLength(255), Validators.pattern(ConstantesApp.CADENA_TEXTO)]],
            numeroPrestamo: ['', [Validators.required, Validators.maxLength(255)]],
            reciboHipoteca: [''],
            orden: [1],
        });
    }

    addBeneficiario(beneficiario: FormGroup) {
        const ultimoBeneficiario = this.beneficiarios.length > 0 ? this.beneficiarios[this.beneficiarios.length - 1] : null;
        const ultimoOrden = ultimoBeneficiario ? ultimoBeneficiario.orden : 0;
        beneficiario.get('orden')?.setValue(ultimoOrden! + 1);
        this.beneficiarioItems.push(beneficiario);
    }


    validarDatosPersonales() {
        if (this.validacionDatosPersonales()) {
            if (!this.validacionFechaNacimiento) {
                this.toastr.error('No se puede finalizar, la fecha de nacimiento no coincide.');
                return;
            }
            this.cliente.nombre = this.formDatosPersonales.controls["nombre"].value;
            this.cliente.apellido1 = this.formDatosPersonales.controls["primerApellido"].value;
            this.cliente.apellido2 = this.formDatosPersonales.controls["segundoApellido"].value;
            this.cliente.identificacion = this.formDatosPersonales.controls['identificacion'].value.toUpperCase();

            this.clienteApiService.actualizar(this.cliente).then(() => {
            }).catch(error => { this.toastr.error('Error al actualizar los datos del cliente.'); });

            this.goToNextStep();
        }
    }

    validacionDatosPersonales() {
        if (!this.formDatosPersonales.valid) {
            this.toastr.error(this.translateService.instant('form.generic.error.general'));
            this.formDatosPersonales.markAllAsTouched();
        }
        return this.formDatosPersonales.valid;
    }

    validaSumaPorcentaje() {
        if (this.beneficiarioItems.length === 1) {
            const unicoBeneficiario = this.beneficiarioItems.at(0);

            if (unicoBeneficiario.get('nombreBanco')?.value) {
                return true;
            }
        }

        let suma: number = 0;
        this.beneficiarioItems.controls.forEach(el => {
            suma += parseInt(el.get("porcentaje")?.value);
        });

        return suma === 100;
    }

    cambiarValidacionEmail(event: any, position: number) {

        let emailForm = this.beneficiarioItems.controls[position]?.get('email');
        if (event) {
            if (emailForm != null) {
                emailForm.setValidators([Validators.required, Validators.maxLength(255), Validators.pattern(ConstantesCore.REGEX_EMAIL_OPCIONAL)]);
                emailForm.updateValueAndValidity();
            }
        } else {
            if (emailForm != null) {
                emailForm.clearValidators();
                emailForm.setValidators([Validators.maxLength(255), Validators.pattern(ConstantesCore.REGEX_EMAIL_OPCIONAL)]);
                emailForm.updateValueAndValidity();
            }
        }
    }

    validarBeneficiarios() {
        let valiBeneficiario = true;
        let existeEnvioEmail = false;
        let diferenteTitular = true;

        for (let index = 0; index < this.beneficiarioItems.length; index++) {
            if (!this.beneficiarioItems.controls[index].valid) {
                this.toastr.error(this.translateService.instant('form.generic.error.general'));
                this.beneficiarioItems.controls[index].markAllAsTouched();
                valiBeneficiario = false;
                break;
            }

            if (!existeEnvioEmail && this.beneficiarioItems.controls[index].get('comunicarEmail')?.value) {
                existeEnvioEmail = true;
            }

            if (diferenteTitular && this.beneficiarioItems.controls[index].get('nombreCompleto')?.value.trim() == this.formDatosPersonales.controls["nombre"].value.trim()) {
                diferenteTitular = false
            }
        }

        let validBeneficiariosAdicional = true;
        if (valiBeneficiario) {
            if (existeEnvioEmail && !this.comunicarBeneficiarios) {
                this.mensajeValidacionForm = this.translateService.instant('beneficiarios.validacion.autoriza.envio.email');
                validBeneficiariosAdicional = false;
            }

            if (!diferenteTitular) {
                this.mensajeValidacionForm = this.translateService.instant('beneficiarios.validacion.titular.diferente');
                validBeneficiariosAdicional = false;
            }

            if (this.poliza.tipoPoliza.id === 2 && this.beneficiarioItems.length == 0) {
                this.mensajeValidacionForm = this.translateService.instant('beneficiarios.validacion.obligatorio.hipoteca');
                validBeneficiariosAdicional = false;
            }

            if (!this.validaSumaPorcentaje() && this.isFamilia) {
                this.mensajeValidacionForm = this.translateService.instant('beneficiarios.validacion.porcentaje.total');
                validBeneficiariosAdicional = false;
            }
        }

        if (valiBeneficiario && validBeneficiariosAdicional) {
            this.mensajeValidacionForm = "";
            this.formCuentaBancaria.get("titularCuenta")?.setValue(this.getNombreCompletoBeneficiario());
            this.goToNextStep();
        }
    }

    agregarBeneficiario() {
        this.addBeneficiario(this.getFormGroupBeneficioVacio(false));
    }

    eliminarBeneficiario(index: number) {
        if (this.beneficiarioItems.length > 1) {
            this.beneficiarioItems.removeAt(index);
            this.mensajeValidacionForm = "";
        } else {
            this.mensajeValidacionForm = this.translateService.instant('beneficiarios.minimo');
        }

    }

    validacionTitularCuentaBancaria() {
        return this.formCuentaBancaria.valid;
    }

    finalizar() {
        if (!this.formCuentaBancaria.valid) {
            this.toastr.error(this.translateService.instant('form.generic.error.general'));
            this.formCuentaBancaria.markAllAsTouched();
            return;
        }

        this.cliente.nombre = this.formDatosPersonales.controls["nombre"].value;
        this.cliente.apellido1 = this.formDatosPersonales.controls["primerApellido"].value;
        this.cliente.apellido2 = this.formDatosPersonales.controls["segundoApellido"].value;
        this.cliente.identificacion = this.formDatosPersonales.controls['identificacion'].value.toUpperCase();
        this.cliente.tipoSexo = new TipoSexo();
        this.cliente.tipoSexo.id = parseInt(this.formDatosPersonales.controls["tipoSexo"].value);
        this.cliente.profesion = this.formDatosPersonales.controls["profesion"].value;
        this.cliente.telefono = this.formDatosPersonales.controls["telefono"].value;

        this.poliza.titularCuenta = this.formCuentaBancaria.controls["titularCuenta"].value;
        this.poliza.ibanCuenta = this.formCuentaBancaria.controls["ibanCuenta"].value.toUpperCase();
        this.poliza.tipoPeriodicidad = new TipoPeriodicidad();
        this.poliza.tipoPeriodicidad.id = parseInt(this.formCuentaBancaria.controls["periodicidad"].value);
        this.poliza.autorizacionEnvioEmail = this.comunicarBeneficiarios;

        this.poliza.beneficiarioList = [];

        let orden = 1;

        this.beneficiarioItems.controls.forEach((el, index) => {
            const beneficiario = new Beneficiario();
            beneficiario.nombreCompleto = el.get("nombreCompleto")?.value;
            beneficiario.porcentaje = el.get("porcentaje")?.value || 0;
            beneficiario.dni = el.get("dni")?.value;
            beneficiario.email = el.get("email")?.value || '';
            beneficiario.comunicarEmail = el.get("comunicarEmail")?.value || false;
            beneficiario.numeroPrestamo = el.get("numeroPrestamo")?.value || '';
            beneficiario.nombreBanco = el.get("nombreBanco")?.value || '';
            beneficiario.clienteId = this.cliente.id!;
            beneficiario.polizaId = this.poliza.id!;
            beneficiario.orden = orden++;
            this.poliza.beneficiarioList.push(beneficiario);

            if (index === 0 && this.poliza.tipoPoliza.id === 2) {
                beneficiario.esBanco = true;
                delete beneficiario['tipoRelacion'];
            } else {
                beneficiario.esBanco = false;
                beneficiario.tipoRelacion = el.get("tipoRelacion")?.value;
            }
        });

        if (this.poliza.beneficiarioList.length === 0) {
            this.toastr.error("Debe ingresar al menos un beneficiario completo.");
            return;
        }

        if (this.poliza.tipoPoliza.id == ConstantesApp.TIPO_POLIZA_HIPOTECA) {
            if (this.formBeneficiarioBanco.get('reciboHipoteca')!.value) {
                this.fileService.uploadFile(this.formDataRecibo).subscribe({
                    next: (res) => {
                        if (res.fecha) {
                            res.fecha = new Date(res.fecha);
                        }
                        this.poliza.archivoReciboHipoteca = res;
                    }
                });
            }
        }

        this.sesion.setCliente(this.cliente);
        this.sesion.setPoliza(this.poliza);

        this.solicitarFirmaCliente();
    }


    private solicitarFirmaCliente() {
        // Comprobar si ventana ya abierta
        const idModal = 'modal-solicitud-firma-cliente';
        const dialog = this.dialog.getDialogById(idModal);
        if (!dialog) {
            const agente = this.poliza?.colectivo?.agente ? this.poliza.colectivo.agente : this.poliza?.tipoPoliza?.agente;
            const dialogRef = this.dialog.open(
                FirmaClienteComunComponent,
                {
                    id: idModal,
                    disableClose: true,
                    panelClass: ['modal-central-ancho'],
                    data: {
                        cliente: this.cliente,
                        agente: agente,
                        titulo: 'firma.titulo.generico',
                        textoDescripcion: '',
                        mostrarUploadDni: this.poliza.tipoPoliza.id === ConstantesApp.TIPO_POLIZA_HIPOTECA,
                        dniObligatorio: false,
                    },
                });

            dialogRef.afterClosed().subscribe(
                (result: { archivoClienteFirma: ArchivoCliente, archivoClienteDni: ArchivoCliente, archivoClienteDniReverso: ArchivoCliente, imageDniBase64: string }) => {
                    if (result) {

                        // temporal
                        if (result.archivoClienteDni?.archivo?.fecha) {
                            result.archivoClienteDni.archivo.fecha = new Date(result.archivoClienteDni.archivo.fecha)
                        }
                        if (result.archivoClienteDniReverso?.archivo?.fecha) {
                            result.archivoClienteDniReverso.archivo.fecha = new Date(result.archivoClienteDniReverso.archivo.fecha)
                        }
                        if (result.archivoClienteFirma?.archivo?.fecha) {
                            result.archivoClienteFirma.archivo.fecha = new Date(result.archivoClienteFirma.archivo.fecha)
                        }

                        this.poliza.archivoClienteFirma = result.archivoClienteFirma;
                        this.poliza.archivoClienteDni = result.archivoClienteDni;
                        this.poliza.archivoClienteDniReverso = result.archivoClienteDniReverso;

                        this.reconocerTexto(result.imageDniBase64);
                        const dialogRefDireccionEnvio = this.dialog.open(
                            ModalDireccionEnvioComponent,
                            { panelClass: 'custom-modal-envio', }
                        );
                        dialogRefDireccionEnvio.afterClosed().subscribe((result) => {
                            if (result === 'confirm') {
                                this.router.navigateByUrl(ConstantesApp.PATH_COLECTIVOS_7_SOLICITUD_CURSO);
                            }
                        });
                    }
                });
        }
    }

    private getNombreCompletoBeneficiario(): string {
        return this.formDatosPersonales.controls["nombre"].value +
            ' ' +
            this.formDatosPersonales.controls["primerApellido"].value +
            (this.formDatosPersonales.controls["segundoApellido"].value ? ' ' + this.formDatosPersonales.controls["segundoApellido"].value : '');
    }

    abrirModalInformativo(event: Event) {
        event.preventDefault();
        const dialogRef = this.dialog.open(ModalPoliticaPrivacidadInformarUsuarioComponent, {
            panelClass: '',
            data: { component: ModalPoliticaPrivacidadInformarUsuarioComponent, mostrarBtnFooter: false },
        });

        dialogRef.afterClosed().subscribe((result) => { });
    }

    onFileChangeRecibo(event: any) {
        const file = event.target.files[0];
        const maxFileSizeMB = 5;
        const maxFileSizeBytes = maxFileSizeMB * 1024 * 1024;
        const validExtensions = [
            'application/pdf',
            'image/jpeg',
            'image/png'
        ];

        if (!validExtensions.includes(file.type)) {
            this.toastr.error(this.translateService.instant('contratar.archivo-no-admitido-recibo'));
            event.target.value = '';
            return;
        }

        if (file.size > maxFileSizeBytes) {
            const errorMessage = this.translateService.instant('contratar.archivo-demasiado-pesado', {
                fileName: file.name,
                maxFileSizeMB: maxFileSizeMB
            });

            this.toastr.error(errorMessage);
            event.target.value = '';
            return;
        }
        
        if (file) {
            this.formBeneficiarioBanco.get('reciboHipoteca')!.setValue(file);
            this.nombreArchivoRecibo = file.name;
            this.formDataRecibo.append('file', file, file.name);
        }
    }

    reconocerTexto(imageSrc: string) {
        if (imageSrc) {
            this.isLoading = true;
            Tesseract.recognize(
                imageSrc,
                'spa'
            ).then(({ data: { text } }) => {
                this.recognizedText = text;
                this.comprobarIdentificacionCliente();
                this.isLoading = false;
            }).catch(error => {
                console.error("Error durante el recnocimiento del texto:", error);
                this.isLoading = false;
            });
        }
    }

    obtenerFechaNacimiento(): string[] {
        const regex = /\b(\d{2} ?\d{2} ?\d{4})\b/g;
        const fechas: string[] = [];
        let match;

        while ((match = regex.exec(this.recognizedText)) !== null) {
            const cleanMatch = match[1].replace(/ /g, '');
            if (cleanMatch.length === 8) {
                const day = cleanMatch.slice(0, 2);
                const month = cleanMatch.slice(2, 4);
                const year = cleanMatch.slice(4, 8);
                const formattedDate: string = `${day}/${month}/${year}`;

                if (this.esFechaDeNacimientoValida(formattedDate)) {
                    fechas.push(formattedDate);
                }
            }
        }

        return fechas;
    }

    private esFechaDeNacimientoValida(fecha: string): boolean {
        const [day, month, year] = fecha.split('/');
        const birthdate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        const age = this.calcularEdad(birthdate);
        return age >= 18 && age <= 65;
    }

    private calcularEdad(fechaNacimiento: Date): number {
        const hoy = new Date();
        let edad = hoy.getFullYear() - fechaNacimiento.getFullYear();
        const m = hoy.getMonth() - fechaNacimiento.getMonth();

        if (m < 0 || (m === 0 && hoy.getDate() < fechaNacimiento.getDate())) {
            edad--;
        }

        return edad;
    }

    comprobarIdentificacionCliente() {
        const textoEnMayusculas = this.recognizedText.toUpperCase().replace(/ /g, "");

        const fechaFormateada = this.convertirFecha(this.cliente.fechaNacimiento).replace(/ /g, "");
        const identificacion = this.formDatosPersonales.controls['identificacion'].value.toUpperCase().replace(/ /g, "");

        if (identificacion) {
            this.poliza.identificacionVerificada = textoEnMayusculas.includes(identificacion);
            this.validacionFechaNacimiento = textoEnMayusculas.includes(fechaFormateada);

            if (!this.validacionFechaNacimiento) {
                const fechasEncontradas = this.obtenerFechaNacimiento();
                this.abrirModalFechaIncorrecta(fechasEncontradas, this.cliente);
            } else {
                this.toastr.success('La fecha de nacimiento coincide con la registrada.');
            }
        }
    }

    convertirFecha(fecha: Date): string {
        const dia = fecha.getDate().toString().padStart(2, '0');
        const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
        const annio = fecha.getFullYear();

        return `${dia} ${mes} ${annio}`;
    }

    abrirModalFechaIncorrecta(fechaDNI: string[], cliente: Cliente) {
        if (fechaDNI.length === 1) {
            const fechaPoliza = this.datePipe.transform(this.cliente.fechaNacimiento, 'dd/MM/yyyy');
            const dialogRef = this.dialog.open(ModalFechaIdentificacionErroneaComponent, {
                panelClass: 'custom-modal-fecha-erronea',
                data: { component: ModalFechaIdentificacionErroneaComponent, mostrarBtnFooter: false, fechaDNI, fechaPoliza, cliente },
            });

            dialogRef.afterClosed().subscribe((result) => {
                if (result === 'fechaCambiada') {
                    this.validacionFechaNacimiento = true;
                    this.toastr.success('Fecha de nacimiento verificada y aplicada correctamente.');
                } else {
                    this.toastr.info('No se realizó ningún cambio en la fecha de nacimiento.');
                }
            });
        } else {
            this.toastr.info('No se ha encontrado ninguna fecha de nacimiento en la imagen.')
        }
    }

    isCurrentStep(step: number): boolean {
        return this.pasoActual === step;
    }

    goToNextStep(): void {
        if (this.pasoActual < this.totalPasos) {
            this.pasoActual++;
        }
    }

    goToPreviousStep(): void {
        if (this.pasoActual > 1) {
            this.pasoActual--;
        }
    }
}
